<template>
  <div class="animations-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "GraphicAnimation",
  props: {},
  methods: {}
};
</script>

<style lang="scss">
</style>
